import { render } from "./AppTopbar.vue?vue&type=template&id=d5c27f14&ts=true"
import script from "./AppTopbar.vue?vue&type=script&lang=ts"
export * from "./AppTopbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__